import styled from 'styled-components';

export const LeadBottomHeader = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;

  span:first-of-type {
    display: inline-block;
    margin-right: 6px;
  }

  & > div {
    margin-right: 15px;
  }
`;

export const LeadSection = styled.section`
  background-color: var(--BackgroundGrey);
  justify-content: space-between;
  align-items: center;
  position: sticky;
  display: flex;
  z-index: 2;
  top: 0;
  margin: 0 -10px;
  padding: 0 10px;

  & > div:first-of-type {
    justify-content: flex-start;
    padding-bottom: 46px;
    align-items: center;
    display: flex;

    & > div:first-of-type ${LeadBottomHeader} {
      border-right: 1px #ebedf2 solid;
      margin-right: 15px;
    }
  }

  & > div:last-of-type {
    justify-content: flex-end;
    align-items: center;
    display: flex;

    & > div {
      align-items: center;
      display: flex;

      & > span {
        color: var(--DarkGray);
        display: inline-block;
        margin: 0 6px 0 20px;
        white-space: nowrap;
        font-size: 14px;
      }
    }
  }
`;

export const LeadTopHeader = styled.div`
  align-items: center;
  padding: 10px 0;
  display: flex;
  height: 35px;

  & > span:first-of-type {
    color: var(--DarkGray);
    font-weight: 700;
    font-size: 18px;
  }

  & > span:nth-child(2) {
    color: var(--DarkGray);
    font-size: 11px;
    margin-top: 5px;
  }
  & > span:nth-child(3) {
    margin-top: 5px;
  }

  & > span {
    margin-right: 6px;
  }
`;

export const TableSection = styled.section`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
export const LightText = styled.span`
  color: rgba(93, 110, 129, 1);
  font-family: 'Proxima Nova';
  font-size: 13px;
  letter-spacing: 0;
  line-height: 18px;
`;
